exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "modal-cadastral-reference .modal-content{padding:43px 30px 50px}modal-cadastral-reference .modal-content.mobile{height:calc(100vh - 75px);overflow-y:scroll;padding-bottom:85px!important}modal-cadastral-reference .modal-content.mobile .modal-header h1{text-align:center}modal-cadastral-reference .modal-header{border-bottom:1px solid #dddfe2;padding-bottom:4px}modal-cadastral-reference .modal-header h1{color:#0072c9;font-family:Stag Sans;font-size:24px;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/myLoans/modals/modalCadastralReference/modalCadastralReference.scss
// module id = 2006
// module chunks = 0